import styled from "styled-components";
import { statActionButtonStyles, statPanelSurface } from "./panelStyles";

export const ReserveRefreshButton = styled.button.attrs<{ $busy?: boolean }>(props => ({ type: "button", "data-busy": props.$busy }))`
	${statActionButtonStyles}
`;

export const Card = styled.div<{ $span?: number }>`
	background: #ffffff;
	border-radius: 16px;
	padding: 20px;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04), 0 2px 12px rgba(0, 0, 0, 0.03);
	display: flex;
	flex-direction: column;
	grid-column: auto / span ${p => p.$span ?? 1};
	height: 100%;
	transition: box-shadow 0.2s;
	&:hover {
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07), 0 4px 20px rgba(0, 0, 0, 0.04);
	}
`;

/** Keep accounting layouts and content while using the statistics card frame. */
export const AccountingCard = styled(Card)`
	${statPanelSurface}
	&:hover { box-shadow: none; }
`;

export const KpiValue = styled.span`
	font-size: 28px;
	font-weight: 700;
	color: #1a1d26;
	line-height: 1.2;
	margin-bottom: 0px;
`;

export const KpiLabel = styled.span`
	font-size: 13px;
	color: #848799;
	margin-top: 2px;
`;

export const Badge = styled.span<{ $positive?: boolean }>`
	display: inline-flex;
	align-items: center;
	gap: 2px;
	font-size: 12px;
	font-weight: 600;
	padding: 2px 8px;
	border-radius: 20px;
	background: ${p => (p.$positive ? "rgba(16,185,129,0.1)" : "rgba(239,68,68,0.1)")};
	color: ${p => (p.$positive ? "#059669" : "#dc2626")};
`;

export const ProgressRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 0;
`;

export const ProgressBarBg = styled.div`
	flex: 1;
	height: 6px;
	border-radius: 3px;
	background: #e8ebee;
	overflow: hidden;
`;

export const ProgressBarFill = styled.div<{ $width: number; $color: string }>`
	height: 100%;
	border-radius: 3px;
	width: ${p => p.$width}%;
	background: ${p => p.$color};
	transition: width 0.6s ease;
`;

export const CardTitle = styled.div`
	font-size: 15px;
	font-weight: 600;
	color: #1a1d26;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const SectionTitle = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: baseline;
	gap: 4px 12px;
	min-width: 0;
	h2 { margin: 0; color: #344054; font-size: 14px; font-weight: 600; line-height: 20px; overflow-wrap: anywhere; }
`;

export const EllipsisLabel = styled.span`
	font-size: 13px;
	color: #1a1d26;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const SectionMeta = styled.span`
	font-size: 11px;
	font-weight: 400;
	color: #98a2b3;
	line-height: 16px;
	text-transform: none;
	letter-spacing: 0;
`;

export const DonutCenter = styled.div`
	position: absolute;
	inset: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

export const DonutValue = styled.span`
	font-size: 26px;
	font-weight: 700;
	color: #1a1d26;
`;

export const DonutLabel = styled.span`
	font-size: 11px;
	color: #848799;
`;

export const LegendDot = styled.span<{ $color: string }>`
	display: inline-block;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: ${p => p.$color};
`;
